import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Checkbox, Select } from 'semantic-ui-react';
import { Button, Field, Icon, Groupper, Header, Input, Table, Toast } from 'react-frontier';
import { bindFormChange } from '../SiteUtil';
import { MetadataType, SetLoading } from '../SiteClasses';
import Validator from '../Validator';

import API from '../API';

interface MetadataValue{
	value_id?: number,
	metadata_id: number,
	value: string,
	edit_mode?: boolean,
	[key: string]: any,
}

interface MetadataQuestion{
	metadata_id?: number,
	type_id: MetadataType,
	metadata_name: string,
	metadata_comment: string,
	default_value: string,
	preadded: boolean,
	values?: MetadataValue[],
	deleted: boolean;
}

function FormQuestion() {
	var params = useParams<{ id: string, qid: string }>();
	var question_id = params.qid;
	var IS_CREATE = question_id === 'create';

	var navigate = useNavigate();
	var [question, setQuestion] = useState<MetadataQuestion>(null);
	var [loadError, setLoadError] = useState<string>(null);

	useEffect(()=>{
		get();
	}, [question_id])

	var get = ()=>{
		if(!IS_CREATE && !Number.isNaN(question_id)) {
			API.getForm(parseInt(question_id)).then(res=>{
				if(res.error) return setLoadError(res.message);
				setQuestion(res.data);
			}).catch(()=>{
				setLoadError('Hubo un error cargando las preguntas (LCL-1)');
			});
		} else {
			setQuestion({
				metadata_name: '',
				type_id: null,
				metadata_comment: '',
				preadded: false,
				default_value: '',
				deleted: false,
			});
		}
	}

	var saveQuestion = (setLoading: SetLoading)=>{
		var { valid, prompts } = Validator(question, {
			metadata_name: [{ rule: 'length', params: [3, 64], label: 'Pregunta' }],
			metadata_comment: [{ rule: 'length', params: [0, 128], label: 'Comentario', skipEmpty: true }],
			
		});
		if(!valid) return Toast.error(prompts[0]);
		setLoading(true);
		if(!IS_CREATE) {
			API.editForm(parseInt(question_id), question.type_id, question.metadata_name, question.metadata_comment, question.preadded, question.default_value).then(res=>{
				if(res.error) return Toast.error(res.message);
				Toast.success('Se ha actualizado la pregunta');
			}).catch(()=>{
				return Toast.error('Hubo un error inesperado actualizando la pregunta (LCL-11)');
			}).finally(()=>{
				setLoading(false);
			});
		} else {
			API.createForm(question.type_id, question.metadata_name, question.metadata_comment, question.preadded, question.default_value).then(res=>{
				if(res.error) return Toast.error(res.message);
				setQuestion(q=>({ ...q, question_id: res.data }))
				navigate(`/forms/${res.data}`);
				Toast.success('Se ha creado la pregunta');
			}).catch(()=>{
				return Toast.error('Hubo un error inesperado creando la pregunta (LCL-11)');
			}).finally(()=>{
				setLoading(false);
			});
		}
	}

	var onOptionChange = (index: number, label: any)=>{
		return (value: any)=>{
			var q = {
				...question,
				values: [...question.values],
			};
			q.values[index][label] = value;
			setQuestion(q);
		}
	}

	var addOption = ()=>{
		return ()=>{
			var q = {
				...question,
				values: question.values ? [...question.values] : [],
			};
			q.values.push({
				metadata_id: question.metadata_id,
				value: '',
				edit_mode: true,
			})
			setQuestion(q);
		}
	}

	var onSaveOption = (option: MetadataValue)=>{
		return (setLoading: SetLoading)=>{
			setLoading(true);
			var { valid, prompts } = Validator(option, {
				value: [{ rule: 'length', params: [1, 128], label: 'Valor' }],
			});
			if(!valid) {
				setLoading(false);
				return Toast.error(prompts[0]);
			}

			if(!!option.value_id) {
				API.editFormValue(option.value_id, option.value).then(res=>{
					if(res.error) return Toast.error(res.message);
					setQuestion(q=>({
						...q,
						values: q.values.map(v=>({ ...v, edit_mode: false, active: option.active }))
					}));
					Toast.success('Se ha actualizado la opción');
				}).catch(()=>{
					return Toast.error('Hubo un error inesperado actualizando la opción (LCL-11)');
				}).finally(()=>{
					setLoading(false);
				});
			} else {
				API.createFormValue(parseInt(question_id), option.value).then(res=>{
					if(res.error) return Toast.error(res.message);
					option.value_id = res.data;
					var values = [...question.values.map(v=>({ ...v, edit_mode: false, value_id: v.value_id || res.data }))]
					setQuestion(q=>({
						...q,
						values
					}));
					Toast.success('Se ha creado la opción');
				}).catch(()=>{
					return Toast.error('Hubo un error inesperado creando la opción (LCL-11)');
				}).finally(()=>{
					setLoading(false);
				});
			}
		}
	}

	var deleteOption = (option: MetadataValue)=>{
		return (setLoading: SetLoading)=>{
			setLoading(true);
			if(option.value_id) {
				API.deleteFormValue(option.value_id).then((res)=>{
					if(res.error) return Toast.error(res.message);
					Toast.success('Se eliminó la opción');
					setQuestion(q=>({
						...q,
						values: q.values.filter(v=>v.value_id !== option.value_id)
					}));
				}).catch(()=>{
					return Toast.error('Hubo un error inesperado actualizando la pregunta (LCL-11)');
				})
			} else {
				setQuestion(q=>({
					...q,
					values: q.values.filter(v=>!!v.value_id)
				}));
			}
		}
	}

	var onDelete = (setLoading: SetLoading)=>{
		setLoading(true);
		API.deleteForm(parseInt(question_id), !question.deleted).then((res)=>{
			if(res.error) return Toast.error(res.message);
			Toast.success('Se eliminó el formulario');
			setQuestion(q=>({
				...q,
				deleted: !q.deleted
			}));
		}).catch(()=>{
			return Toast.error('Hubo un error inesperado actualizando el fromulario (LCL-11)');
		}).finally(()=>{
			setLoading(false);
		});
	}



	if(loadError) return <Header text='Error' subtext={loadError} />;
	if(!question) return <Header text='Cargando datos' loading />;

	var onFormChange = bindFormChange(question, setQuestion);
	var someOptionIsEdit = question?.values?.some(v=>v.edit_mode)

	return (
		<div>
			<Groupper
				title={`${IS_CREATE ? 'Crear' : 'Editar'} pregunta`}
				style={{ marginBottom: 10, marginTop: 20 }}
				width={600}
				actions={<div>
					<Button text={question.deleted ? 'Restaurar' : 'Eliminar'} basic color={question.deleted ? 'green' : 'red'} onClick={onDelete} style={{ marginRight: 5 }}/>
					<Button text="Guardar" color="black" onClick={saveQuestion} />
				</div>}
			>
				<div style={{ width: '100%', height: 'auto' }}>
					<Input label="Pregunta" placeholder="Pregunta" value={question.metadata_name} onChange={onFormChange('metadata_name')} />
					<Field amount={2} style={{ marginBottom: 0 }}>
						<Field label="Tipo de pregunta">
							<Select
								fluid
								value={question.type_id}
								onChange={onFormChange('type_id', true)}
								placeholder="Tipo de pregunta"
								options={[
									{ text: 'Texto', value: MetadataType.INPUT },
									{ text: 'Texto largo', value: MetadataType.TEXTAREA },
									{ text: 'Opciones', value: MetadataType.DROPDOWN },
									{ text: 'Si / No', value: MetadataType.CHECKBOX },
								]}
							/>
						</Field>
						<Input label="Comentario" placeholder="Comentario" value={question.metadata_comment} onChange={onFormChange('metadata_comment')} />
					</Field>
					<Field amount={2}>
						<Field>
							<Checkbox
								toggle
								label="Pre-agregada"
								onChange={onFormChange('preadded', true)}
								checked={!!question.preadded}
								style={{ marginBottom: 10 }}
							/>
						</Field>
					</Field>
				</div>
			</Groupper>

			{!IS_CREATE && [MetadataType.MULTIPLE, MetadataType.DROPDOWN].includes(question.type_id) && (
				<Table
					striped
					title='Opciones'
					button={(
						<Button disabled={someOptionIsEdit} size="tiny" iconName='plus-circle' text="Agregar" color="black" onClick={addOption()} />
					)}
					headers={['ID', 'Valor', <Icon name={'pen'} />, <Icon name='remove' />]}
					collapsingIndexes={[0, 2, 3]}
					centeredIndexes={[2, 3]}
					style={{ maxWidth: 600, margin: 'auto' }}
				>
					{(!question.values || question.values.length === 0) ? (
						<Table.Cell row colSpan={5}>
							No hay opciones en esta pregunta
						</Table.Cell>
					) : question.values.map((a, index)=>(
						<tr key={`val-${a.value_id}-${index}`}>
							{!a.edit_mode ? (
								<>
									<td>{a.value_id}</td>
									<td>{a.value}</td>
									<td style={{ textAlign: 'center' }}>
										<Button
											disabled={someOptionIsEdit}
											iconName="pencil"
											className="tiny"
											onClick={()=>{
												setQuestion(q=>({
													...q,
													values: q.values.map(qv=>({
														...qv,
														edit_mode: qv.value_id === a.value_id
													}))
												}));
											}}
										/>
									</td>
									<td style={{ textAlign: 'center' }}>
										<Button disabled={someOptionIsEdit} iconName="remove" className="tiny" onClick={deleteOption(a)} />
									</td>
								</>
							) : (
								<>
									<td>{a.value_id}</td>
									<td>
										<Input
											placeholder="Nueva Opción"
											value={a.value}
											onChange={onOptionChange(index, 'value')}
											style={{ margin: 0, width: '66%' }}
										/>
									</td>
									<td>
										<Button size='tiny' iconName='check-circle' color="green" onClick={onSaveOption(a)} />
									</td>
									<td>
										<Button size='tiny' iconName="remove" className="tiny" onClick={deleteOption(a)} />
									</td>
								</>
							)}
						</tr>
					))}
				</Table>
			)}
		</div>
	);
}

export default FormQuestion;
